import React from 'react';
import PauseAnyTimeSellingPointMobile from '../../../../experiments/success_guarantee_modal_exp/pause_any_time_selling_point';
import SuccessGuaranteeSellingPointMobile from '../../../../experiments/success_guarantee_modal_exp/success_guarantee_selling_point_mobile';
import {
  trackUpgradeFormSelectOption,
  trackViewSuccessGaurenteeExpandedText,
  trackPauseAnyTimeSellingPoint,
} from '../../tracking/event';
import './product_selector.scss';

const ProductSelector = ({
  currentProduct,
  context,
  updateCart,
  currencySymbol,
  customer,
  miscellaneous,
  products,
  localisations,
  experiments,
}) => {
  const productRows = products.map((product) => (
    <ProductRow
      key={product.id}
      product={product}
      selectedOption={currentProduct.id == product.id}
      context={context}
      updateCart={updateCart}
      currencySymbol={currencySymbol}
      customer={customer}
      miscellaneous={miscellaneous}
      localisations={localisations}
      experiments={experiments}
    />
  ));
  return (
    <form className="product-selector">
      <ul className="product-selector__rows">{productRows}</ul>
    </form>
  );
};

const ProductRow = (props) => {
  const rowClassName = `product-selector__row${
    props.selectedOption ? ' product-selector__row--selected' : ''
  }`;
  const originalPrice = props.product.original_price ? (
    <del aria-hidden="true" className="product-selector__original-price">
      <span className="price-currency">{props.currencySymbol}</span>
      <span className="price">{props.product.original_price}</span>
    </del>
  ) : (
    ''
  );
  const productSelected = () => {
    props.updateCart(props.product);
    trackUpgradeFormSelectOption({
      label: `${props.miscellaneous.context}|${props.customer.initial_type}|${props.product.price}|${props.product.duration}`,
    });
  };

  const hide_cost_per_day =
    props.customer.initial_type === 'seeker' &&
    props.context.context === 'my_account' &&
    props.product.id != '1006';

  const sellingPoints = () =>
    props.product.selling_points[props.context.product_type].map(
      (sellingPoint, index) => {
        sellingPoint =
          sellingPoint.includes('Pause your upgrade') &&
          props.context.context != 'global' ? (
            <PauseAnyTimeSellingPointMobile
              productType={props.context.product_type}
              sellingPoint={'Pause your upgrade'}
              subText={' (once per 4 week saver)'}
              onOpen={trackPauseAnyTimeSellingPoint}
            />
          ) : sellingPoint.includes('Success guaranteed') ? (
            <SuccessGuaranteeSellingPointMobile
              sellingPoint={'Success guaranteed'}
              subText={' (or get another 4 weeks free)'}
              onOpen={trackViewSuccessGaurenteeExpandedText}
            />
          ) : (
            sellingPoint
          );
        return !hide_cost_per_day || (hide_cost_per_day && index != 1) ? (
          <li className="product-selector__selling-point" key={index}>
            <i className="far fa-check-circle product-selector__check" />{' '}
            <span>{sellingPoint}</span>
          </li>
        ) : null;
      },
    );
  return (
    <li className={rowClassName}>
      <label
        className="product-selector__label"
        htmlFor={`id${props.product.id}`}
      >
        <div className="product-selector__name">
          <input
            className="product-selector__option"
            onChange={() => productSelected()}
            checked={props.selectedOption}
            type="radio"
            name="product"
            id={`id${props.product.id}`}
          />
          {props.product.name}
        </div>
        <div className="product-selector__pricing">
          {originalPrice}
          <span className="product-selector__price">
            {props.currencySymbol + props.product.price}
          </span>
        </div>
        <ul className="product-selector__selling-points exp-visible">
          {sellingPoints()}
        </ul>
        <p className="product-selector__promise exp-visible">
          {props.localisations.not_a_subscription}
        </p>
      </label>
    </li>
  );
};

export default ProductSelector;
